import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ROUTING, TAG_MEMORY, PATH } from '../../../../constants';
import './HomeFoot.css';

class HomeFoot extends Component {
  componentDidMount() {

  }

  render() {
    const imgLinkStyle = {
      backgroundImage: `url(${PATH.IMG}homepage/home-menu-sheet.png)`,
    };

    return (
      <div className="home-foot-line">
        <a
          className="img-link tv"
          href="//www.ceskatelevize.cz/specialy/totostoleti/program-68"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div
            className="link-in"
            style={imgLinkStyle}
          />
        </a>
        <Link
          className="img-link vysilani"
          to={ROUTING.VYSILANI}
        >
          <div
            style={imgLinkStyle}
            className="link-in"
          />
        </Link>
        <a
          className="img-link anniversary"
          href="//www.ceskatelevize.cz/porady/vyroci/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div
            className="link-in"
            style={imgLinkStyle}
          />
        </a>
        <Link
          className="img-link memory"
          to={`${ROUTING.TAG}/${TAG_MEMORY}`}
        >
          <div
            style={imgLinkStyle}
            className="link-in"
          />
        </Link>
        <Link
          className="img-link school"
          to={ROUTING.SCHOOL}
        >
          <div
            style={imgLinkStyle}
            className="link-in"
          />
        </Link>
        <Link
          className="img-link map"
          to={ROUTING.MAP}
        >
          <div
            style={imgLinkStyle}
            className="link-in"
          />
        </Link>
      </div>
    );
  }
}

export default HomeFoot;



// WEBPACK FOOTER //
// ./src/components/App/Home/HomeFoot/HomeFoot.js